

















import { defineComponent, computed, getCurrentInstance } from "vue";
import UiButton from "@dpa-id-components/ui-button";
import UiIcon from "@dpa-id-components/ui-icon";
import "@dpa-id-components/ui-icon/dist/UiIcon.css";
import useSharedSearch from "@/composition/useSharedSearch";
import store from "@/store";
import { filterRules } from "@/utils/filterRules";

export default defineComponent({
  components: { UiButton, UiIcon },
  setup() {
    const root = getCurrentInstance();
    const { saveSharedFilter, showDialog } = useSharedSearch();

    const currentSavedSearch = computed(() =>
      store.getters["filters/getFilterById"](root?.proxy.$route.query.filterId)
    );

    const showShareSearchButton = computed(
      () =>
        currentSavedSearch.value &&
        !currentSavedSearch.value.isPublic &&
        filterRules.length
    );

    return {
      saveSharedFilter,
      currentSavedSearch,
      showShareSearchButton,
      showDialog
    };
  }
});
